import firebase from "firebase/app";
import "firebase/storage";

const uploadFile = (file: File) =>
    new Promise(
        (
            resolve: (downloadUrl: string) => void,
            reject: (error: string) => void
        ) => {
            const storage = firebase.storage().ref();
            const uploadTask = storage
                .child("images")
                .child(Date.now().toString())
                .put(file);
            uploadTask.on(
                firebase.storage.TaskEvent.STATE_CHANGED,
                (_snapshot) => {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                },
                (error) => {
                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    // eslint-disable-next-line default-case
                    switch (error.code) {
                        case "storage/unauthorized":
                            reject(
                                `User doesn't have permission to access the object`
                            );
                            break;

                        case "storage/canceled":
                            reject(`User canceled the upload`);
                            break;

                        case "storage/unknown":
                            reject(
                                `Unknown error occurred, inspect error.serverResponse`
                            );
                            break;
                    }
                },
                () => {
                    // Upload completed successfully, now we can get the download URL
                    uploadTask.snapshot.ref
                        .getDownloadURL()
                        .then((downloadURL) => {
                            resolve(downloadURL);
                        });
                }
            );
        }
    );

export default uploadFile;
